import * as React from 'react';
import * as moment from 'moment';

import { SETTINGS } from 'core/config/settings';

export class SystemTimezone extends React.Component<any> {
  public render() {
    const zone = SETTINGS.defaultTimeZone;
    return (<span>{moment.tz(Date.now(), zone).zoneAbbr()}</span>);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/utils/SystemTimezone.tsx